const _processApplication = async (ctx, { $services, state, $token }) => {
  const { commit, rootState } = ctx;
  const hostname = rootState.hostname;
  const { data } = await $services._core.application().getApplicationSettingsByHostname(process.env.APPLICATION_ALIAS, hostname);

  if ((data.ies || data.tenant) && hostname !== process.env.APPLICATION_OPERATION_HOSTNAME) {
    commit('SET_TENANT_ALIAS', data.tenant.alias);
    commit('SET_TENANT', data.tenant);
    if (data.ies) {
      commit('SET_IES_ALIAS', data.ies.alias);
      commit('SET_INSTITUTION', data.ies);
    }
  }

  commit('_core/application/SET_AUTHENTICATION_MODES', data.authenticationModes, { root: true });
  commit('_core/application/SET_THEMES', data.theme, { root: true });
  commit('_core/application/SET_LOGIN_PAGE_IMAGE', data.theme, { root: true });
  commit('_core/application/SET_LOGO', data.theme, { root: true });
  commit('_core/application/SET_CAPTCHA_KEY', data.captchaKey, { root: true });

  const { tenant, ies, application, owner } = data;

  const defaultEnvironmentLanguageId = ies?.languageId || tenant?.languageId || null;
  const languageId = state._core.user?.languageId || defaultEnvironmentLanguageId;
  commit('_core/locales/SET_LANG', languageId, { root: true });
  commit('_core/locales/SET_DEFAULT_LANG', defaultEnvironmentLanguageId, { root: true });
  commit('_core/application/SET_IS_OPERATION', owner === null, { root: true });
  commit('_core/application/SET_OWNER', owner, { root: true });
  commit('_core/application/SET_CREATE_ACCOUNT', application.createAccountEnabled, { root: true });
};

export default {
  /** @deprecated in favor of application store with Safe A v3 */
  async init(ctx) {
    await _processApplication(ctx, this);
  },

  async changeTheme({ commit, rootState }, { tenant, ies }) {
    if (rootState._core.auth.currentRole) {
      const currentRole = rootState._core.auth.currentRole;
      if (currentRole.tenant?.alias === tenant?.alias && currentRole.ies?.alias === ies?.alias) {
        return;
      }
    }

    await _processApplication({ commit, rootState }, this);
  }
};
